import * as React from "react";

import { ContractFamilyConfigurationModal } from "@/components/modals/ContractFamilyConfigurationModal";
import { Button } from "@/components/ui/button";
import { useCanConfigureContractFamilies } from "@/hooks/use-contract-families-access";

interface Props {
  /** Names of the missing settings, as returned by `useContractSummaryReadiness`. */
  missing: string[];
}

const listSettings = (names: string[]) =>
  names.length > 1 ? `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}` : names[0];

/** Explains which Contract Family settings block a contract summary and lets an administrator fix them in place. */
export const ContractSummarySettingsNotice: React.FC<Props> = ({ missing }) => {
  const canConfigureContractFamilies = useCanConfigureContractFamilies();
  const [isSettingsOpen, setIsSettingsOpen] = React.useState(false);

  return (
    <div role="alert" className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900">
      <p>
        Contract summaries cannot be created yet: the {listSettings(missing)} {missing.length > 1 ? "are" : "is"} not
        set or no longer available.
      </p>
      {canConfigureContractFamilies ? (
        <>
          <Button type="button" variant="outline" size="sm" className="mt-2" onClick={() => setIsSettingsOpen(true)}>
            Open Contract Family settings
          </Button>
          <ContractFamilyConfigurationModal open={isSettingsOpen} onOpenChange={setIsSettingsOpen} />
        </>
      ) : (
        <p className="mt-1">Ask an organization administrator to complete the Contract Family settings.</p>
      )}
    </div>
  );
};
